<template>
	<div id="app">
		<Navs />
		<router-view />
	</div>
</template>

<script>
	import Navs from './components/Navs.vue'
	export default {
		name: 'app',
		components: {
			Navs
		},
		data() {
			return {

			}
		},
		mounted() {

		},
		methods: {

		}
	}
</script>


<style>
	* {
		margin: 0;
		padding: 0;
		user-select: none;
	}

	html,
	body {
		width: 100%;
		height: 100%;
	}

	#app {
		width: 100%;
		height: 100%;
	}








	/* 手机设备和屏幕小于1200px时生效 */
	@media only screen and (max-width: 1200px) {
		
	}
</style>
